import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './TechStack.css';

const ICON = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons';

const categories = [
  {
    id: 'backend',
    label: 'Backend',
    items: [
      { name: '.NET Core', icon: `${ICON}/dotnetcore/dotnetcore-original.svg` },
      { name: 'C#', icon: `${ICON}/csharp/csharp-original.svg` },
      { name: 'ASP.NET', icon: `${ICON}/dot-net/dot-net-original.svg` },
      { name: 'PHP', icon: `${ICON}/php/php-original.svg` },
      { name: 'Laravel', icon: `${ICON}/laravel/laravel-original.svg` },
      { name: 'Symfony', icon: `${ICON}/symfony/symfony-original.svg` },
      { name: 'Node.js', icon: `${ICON}/nodejs/nodejs-original.svg` },
      { name: 'Express', icon: `${ICON}/express/express-original.svg` },
      { name: 'Python', icon: `${ICON}/python/python-original.svg` },
      { name: 'Java', icon: `${ICON}/java/java-original.svg` },
    ],
  },
  {
    id: 'frontend',
    label: 'Frontend',
    items: [
      { name: 'React', icon: `${ICON}/react/react-original.svg` },
      { name: 'Angular', icon: `${ICON}/angularjs/angularjs-original.svg` },
      { name: 'Vue.js', icon: `${ICON}/vuejs/vuejs-original.svg` },
      { name: 'Next.js', icon: `${ICON}/nextjs/nextjs-original.svg` },
      { name: 'TypeScript', icon: `${ICON}/typescript/typescript-original.svg` },
      { name: 'JavaScript', icon: `${ICON}/javascript/javascript-original.svg` },
      { name: 'HTML5', icon: `${ICON}/html5/html5-original.svg` },
      { name: 'CSS3', icon: `${ICON}/css3/css3-original.svg` },
      { name: 'Bootstrap', icon: `${ICON}/bootstrap/bootstrap-original.svg` },
      { name: 'Tailwind CSS', icon: `${ICON}/tailwindcss/tailwindcss-original.svg` },
    ],
  },
  {
    id: 'mobile',
    label: 'Mobile',
    items: [
      { name: 'iOS', icon: `${ICON}/apple/apple-original.svg` },
      { name: 'Swift', icon: `${ICON}/swift/swift-original.svg` },
      { name: 'Android', icon: `${ICON}/android/android-original.svg` },
      { name: 'Kotlin', icon: `${ICON}/kotlin/kotlin-original.svg` },
      { name: 'React Native', icon: `${ICON}/react/react-original.svg` },
      { name: 'Flutter', icon: `${ICON}/flutter/flutter-original.svg` },
      { name: 'Xamarin', icon: `${ICON}/xamarin/xamarin-original.svg` },
      { name: '.NET MAUI', icon: `${ICON}/dotnetcore/dotnetcore-original.svg` },
      { name: 'Ionic', icon: `${ICON}/ionic/ionic-original.svg` },
      { name: 'Firebase', icon: `${ICON}/firebase/firebase-original.svg` },
    ],
  },
  {
    id: 'database',
    label: 'Database',
    items: [
      { name: 'SQL Server', icon: `${ICON}/microsoftsqlserver/microsoftsqlserver-original.svg` },
      { name: 'MySQL', icon: `${ICON}/mysql/mysql-original.svg` },
      { name: 'PostgreSQL', icon: `${ICON}/postgresql/postgresql-original.svg` },
      { name: 'MongoDB', icon: `${ICON}/mongodb/mongodb-original.svg` },
      { name: 'Redis', icon: `${ICON}/redis/redis-original.svg` },
      { name: 'SQLite', icon: `${ICON}/sqlite/sqlite-original.svg` },
      { name: 'Oracle', icon: `${ICON}/oracle/oracle-original.svg` },
      { name: 'Firebase', icon: `${ICON}/firebase/firebase-original.svg` },
    ],
  },
  {
    id: 'devops',
    label: 'Cloud & DevOps',
    items: [
      { name: 'Azure', icon: `${ICON}/azure/azure-original.svg` },
      { name: 'Docker', icon: `${ICON}/docker/docker-original.svg` },
      { name: 'Kubernetes', icon: `${ICON}/kubernetes/kubernetes-original.svg` },
      { name: 'GitHub', icon: `${ICON}/github/github-original.svg` },
      { name: 'GitLab', icon: `${ICON}/gitlab/gitlab-original.svg` },
      { name: 'Nginx', icon: `${ICON}/nginx/nginx-original.svg` },
      { name: 'Linux', icon: `${ICON}/linux/linux-original.svg` },
      { name: 'AWS', icon: `${ICON}/amazonwebservices/amazonwebservices-original-wordmark.svg` },
    ],
  },
  {
    id: 'cms',
    label: 'CMS',
    items: [
      { name: 'WordPress', icon: `${ICON}/wordpress/wordpress-original.svg` },
      { name: 'Drupal', icon: `${ICON}/drupal/drupal-original.svg` },
      { name: 'Magento', icon: `${ICON}/magento/magento-original.svg` },
      { name: 'Shopify', icon: 'https://cdn.simpleicons.org/shopify/7AB55C' },
    ],
  },
  {
    id: 'digital',
    label: 'Digital Marketing',
    items: [
      { name: 'Google Analytics', icon: 'https://cdn.simpleicons.org/googleanalytics/E37400' },
      { name: 'Google Ads', icon: 'https://cdn.simpleicons.org/googleads/4285F4' },
      { name: 'Meta Ads', icon: 'https://cdn.simpleicons.org/meta/0668E1' },
      { name: 'Mailchimp', icon: 'https://cdn.simpleicons.org/mailchimp/FFE01B' },
      { name: 'HubSpot', icon: 'https://cdn.simpleicons.org/hubspot/FF7A59' },
      { name: 'Search Console', icon: 'https://cdn.simpleicons.org/googlesearchconsole/458CF5' },
    ],
  },
];

const TechIcon = ({ item }) => {
  const [failed, setFailed] = useState(false);
  const initials = item.name.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase();

  return (
    <div className="tech-item">
      {failed ? (
        <span className="tech-item-fallback">{initials}</span>
      ) : (
        <img src={item.icon} alt="" onError={() => setFailed(true)} />
      )}
      <span>{item.name}</span>
    </div>
  );
};

const TechStack = () => {
  const [active, setActive] = useState('backend');
  const current = categories.find((category) => category.id === active);

  return (
    <section className="tech-stack-section section" id="technologies">
      <div className="container">
        <p className="eyebrow" style={{ display: 'block', textAlign: 'center' }}>Technology stack</p>
        <h2 className="section-title">Technologies we work with</h2>
        <p className="section-subtitle">
          The same stacks product teams already hire for, grouped the way delivery actually happens.
        </p>

        <div className="tech-tabs" role="tablist">
          {categories.map((category) => (
            <button
              key={category.id}
              type="button"
              role="tab"
              aria-selected={active === category.id}
              className={`tech-tab ${active === category.id ? 'active' : ''}`}
              onClick={() => setActive(category.id)}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="tech-grid" role="tabpanel">
          {current.items.map((item) => (
            <TechIcon key={`${current.id}-${item.name}`} item={item} />
          ))}
        </div>

        <div className="text-center" style={{ marginTop: '2.25rem' }}>
          <Link to="/services" className="tech-stack-link">
            See how we use these in delivery
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
